import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { InitialTestimonials } from './components/TestimonialsSection';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductOverviewSection } from './components/ProductOverviewSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { PackEliteSection } from './components/PackEliteSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FooterSection } from './components/FooterSection';
import { CatalogSection } from './components/CatalogSection';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window,document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1904779843432668');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1904779843432668&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-navy-900 text-white font-sans selection:bg-magenta-500/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <InitialTestimonials data-id="element-3" />
        <PainPointsSection data-id="element-4" />
        <ProductOverviewSection data-id="element-5" />
        <TomosSection data-id="element-6" />
        <BonosSection data-id="element-7" />
        <PricingSection data-id="element-8" />
        <PackEliteSection data-id="element-9" />
        <ExtendedTestimonials data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <ComparisonSection data-id="element-13" />

        {/* Final CTA Section - Reusing Pricing */}
        <div className="bg-navy-950 border-t border-navy-800 pt-12" data-id="element-14">
          <PricingSection data-id="element-15" />
        </div>
        <CatalogSection data-id="element-16" />
      </main>
      <FooterSection data-id="element-17" />
    </div>;
}